import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const columns = [
  {
    title: 'Platform',
    links: [
      { label: 'How It Works',      to: '/how-it-works' },
      { label: 'Browse Experts',    to: '/experts' },
      { label: 'Become an Expert',  to: '/register' },
      { label: 'Categories',        to: '/categories' },
    ],
  },
  {
    title: 'Learning',
    links: [
      { label: 'My Progress',                      to: '/progress' },
      { label: 'Tourent Cycle Activities',          to: '/progress' },
      { label: 'Book a Session',                    to: '/bookings' },
      // { label: 'My Sessions',                       to: '/sessions' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us',   to: '/about' },
      { label: 'Experts',    to: '/experts' },
      // { label: 'Contact',    to: '/about' },
      { label: 'Sign Up',    to: '/register' },
    ],
  },
];

const Footer = () => (
  <footer className="bg-cream-100 border-t border-cream-200 py-12 px-6 lg:px-10">
    <div className="max-w-7xl mx-auto">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">

        {/* Brand */}
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-baseline gap-0.5 mb-3 w-fit">
            <span className="font-serif font-semibold text-forest-900 text-xl">TourEnt</span>
            <span className="font-serif font-semibold text-forest-500 text-xl"> Hub</span>
          </Link>
          <p className="text-sm text-forest-600/70 leading-relaxed max-w-[200px]">
            Premier entrepreneurship capacity building platform.
          </p>
          <div className="flex items-center gap-1.5 mt-3 text-xs text-forest-500">
            <MapPin size={12} /> Accra, Ghana
          </div>
        </div>

        {/* Nav columns */}
        {columns.map((col) => (
          <div key={col.title}>
            <h4 className="font-semibold text-forest-900 text-sm mb-4 tracking-wide">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-forest-600/70 hover:text-forest-900 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="pt-8 border-t border-cream-200 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-forest-600/50">
        <span>© {new Date().getFullYear()} TourEnt Hub. All rights reserved.</span>
        <span>Powered by SnapInk Solutions</span>
      </div>
    </div>
  </footer>
);

export default Footer;